// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-profil>div{display:block;height:35px;padding-top:10px}.info-profil>div:last-child{display:block;margin-bottom:0}.item-icon{margin-top:0}.info-profil{color:#00475a;font-size:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
